import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ApplyLeave, wfhCanceledbyUser, ChangeWfhStatus, HttpResponse, WfhDetail, WfhRequests, WfhRequestDetail, ApplyWfh } from "../public-api";
import { CommonWebService } from "./commonweb.service";
import { UserHttpService } from "./user-session.service";

@Injectable({
  providedIn: 'root'
})
export class WfhManagementService {

  constructor(
    private userSessionService: UserHttpService,
    private commonService: CommonWebService,
    private http: HttpClient
  ) { }


  applyWfh(body: ApplyWfh, isEdit: boolean = false): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("leave_type", body.leave_type ? body.leave_type : "");
    formData.append(
      "wfh_type",
      body.wfh_type != null && body.wfh_type !== "" ? String(body.wfh_type) : ""
    );
    formData.append("from_date", body.from_date ? this.commonService.changeDateFormat(new Date(body.from_date)) : "");
    formData.append("leave_description", body.leave_description ? body.leave_description : "");
    formData.append("leave_purpose", body.leave_purpose ? body.leave_purpose : "");
    formData.append("wfh_status", '1');
    if (String(body.wfh_type) === "2") {
      formData.append("start_time", body.start_time ? body.start_time : "");
      formData.append("end_time", body.end_time ? body.end_time : "");
      // Same calendar day as half-day WFH; API often validates "Leave To" / to_date as required.
      formData.append(
        "to_date",
        body.from_date ? this.commonService.changeDateFormat(new Date(body.from_date)) : ""
      );
    } else {
      formData.append("to_date", body.to_date ? this.commonService.changeDateFormat(new Date(body.to_date)) : "");
    }
    if (isEdit) {
      formData.append('wfh_id', body.wfh_id ? body.wfh_id : "");
    }
    return this.http.post<HttpResponse<any>>("leaves/workFromHome", formData);
  }
  //List Work From Home
  getWfhRequests(
    keyword?: string,
    from_date?: Date,
    to_date?: Date,
    leaveType?: string,
    limit?: number,
    offset?: number
  ): Observable<HttpResponse<WfhRequestDetail[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("request", '1');
    if (keyword) {
      formData.append("keyword_search", keyword ? keyword : '');
    }
    if (from_date) {
      formData.append("from_date", from_date ? this.commonService.changeDateFormat(from_date) : '');
    }
    if (to_date) {
      formData.append("to_date", to_date ? this.commonService.changeDateFormat(to_date) : '');
    }
    if (leaveType) {
      formData.append("leaveType", leaveType ? leaveType : '');
    }
    if (limit !== undefined) {
      formData.append('limit', limit.toString());
    }
    if (offset !== undefined) {
      formData.append('offset', offset.toString());
    }

    return this.http.post<HttpResponse<WfhRequestDetail[]>>('leaves/workFromHome/workFromHomeList', formData);
  }
  //List Work From Home
  myWorkFromHomeList(
    keyword?: string,
    from_date?: Date,
    to_date?: Date,
    leave_type?: string,
    limit?: number,
    offset?: number
  ): Observable<HttpResponse<WfhRequestDetail[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    if (keyword) {
      formData.append("keyword_search", keyword ? keyword : '');
    }
    if (from_date) {
      formData.append("from_date", from_date ? this.commonService.changeDateFormat(from_date) : '');
    }
    if (to_date) {
      formData.append("to_date", to_date ? this.commonService.changeDateFormat(to_date) : '');
    }
    if (leave_type) {
      formData.append("leaveType", leave_type ? leave_type : '');
    }
    if (limit !== undefined) {
      formData.append('limit', limit.toString());
    }
    if (offset !== undefined) {
      formData.append('offset', offset.toString());
    }
    return this.http.post<HttpResponse<WfhRequestDetail[]>>('leaves/workFromHome/workFromHomeList', formData);
  }
  //get WFH detail
  getwhfDetail(id: string): Observable<HttpResponse<WfhRequestDetail[]>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("wfh_id", id ? id : "");
    return this.http.post<HttpResponse<WfhRequestDetail[]>>('leaves/workFromHome/wfhDetail', formData);
  }

  //accept /decline wfh
  cancelWfh(body: wfhCanceledbyUser): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("wfh_status", body.wfh_status ? '3' : "");
    formData.append("wfh_id", body.wfh_id ? body.wfh_id : "");
    return this.http.post<HttpResponse<any>>('leaves/workFromHome/wfhCancelByUser', formData);
  }

  //accept /decline / reject
  changeWfhStatus(body: ChangeWfhStatus): Observable<HttpResponse<any>> {
    let formData = new FormData();
    formData.append("user_id", this.userSessionService.getUserInfo.user_id);
    formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
    formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
    formData.append("token", this.userSessionService.userToken);
    formData.append("wfh_id", body.wfh_id ? body.wfh_id : "");
    formData.append("wfh_status", body.wfh_status ? body.wfh_status : "");
    formData.append("comments", body.comments ? body.comments : "");
    return this.http.post<HttpResponse<any>>('leaves/WfhAcceptDecline', formData);
  }
}
